"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_1 = require("@brandfree-front/lib");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const GaButton_1 = __importDefault(require("../../../util/GaButton"));
const StoresUtil_1 = require("../../../util/StoresUtil");
const ContactForm_1 = require("../../contactform/ContactForm");
const crm_components_1 = require("crm-components");
let RightsPersonalDataContent = class RightsPersonalDataContent extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "locationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "publicPrivacyNoticeStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { translate } = this.translateStore;
        return (react_1.default.createElement(lib_1.List, { spacing: "medium" },
            react_1.default.createElement(lib_1.ListItem, null,
                react_1.default.createElement(lib_1.Text, null,
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("b", null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item1.heading')),
                        "\u00A0",
                        translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item1.content')),
                    react_1.default.createElement("p", null, this.getExtraInfoElement('access-data-contact-form', ContactForm_1.ContactFormType.ACCESS_DATA)))),
            react_1.default.createElement(lib_1.ListItem, null,
                react_1.default.createElement(lib_1.Text, null,
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("b", null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item2.heading')),
                        "\u00A0",
                        translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item2.content')),
                    react_1.default.createElement("p", null, this.getExtraInfoElement('correct-data-contact-form', ContactForm_1.ContactFormType.CORRECT_DATA)))),
            react_1.default.createElement(lib_1.ListItem, null,
                react_1.default.createElement(lib_1.Text, null,
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("b", null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item3.heading')),
                        "\u00A0",
                        translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item3.content')),
                    react_1.default.createElement(lib_1.List, null,
                        react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item3.list.item1')),
                        react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item3.list.item2')),
                        react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item3.list.item3')),
                        react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item3.list.item4')),
                        react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item3.list.item5')),
                        react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item3.list.item6'))),
                    react_1.default.createElement("p", null, this.getExtraInfoElement('forgotten-contact-form', ContactForm_1.ContactFormType.FORGOTTEN)))),
            react_1.default.createElement(lib_1.ListItem, null,
                react_1.default.createElement(lib_1.Text, null,
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("b", null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item4.heading')),
                        "\u00A0",
                        translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item4.content1')),
                    react_1.default.createElement(lib_1.List, null,
                        react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item4.content.list.item1')),
                        react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item4.content.list.item2')),
                        react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item4.content.list.item3')),
                        react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item4.content.list.item4')),
                        react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item4.content.list.item5'))),
                    react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item4.content2')),
                    react_1.default.createElement("p", null, this.getExtraInfoElement('limit-processing-contact-form', ContactForm_1.ContactFormType.LIMIT_PROCESSING)))),
            react_1.default.createElement(lib_1.ListItem, null,
                react_1.default.createElement(lib_1.Text, null,
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("b", null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item5.heading')),
                        "\u00A0",
                        translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item5.content')),
                    react_1.default.createElement("p", null, this.getExtraInfoElement('contact-us-contact-form', ContactForm_1.ContactFormType.CONTACT_US)))),
            react_1.default.createElement(lib_1.ListItem, null,
                react_1.default.createElement(lib_1.Text, null,
                    react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item6.content1')),
                    react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item6.content2')),
                    react_1.default.createElement(lib_1.List, null,
                        react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item6.content2.list.item1')),
                        react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item6.content2.list.item2')),
                        react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item6.content2.list.item3')),
                        react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item6.content2.list.item4'))),
                    react_1.default.createElement("p", null, this.getExtraInfoElement('data-transfer-contact-form', ContactForm_1.ContactFormType.DATA_TRANSFER)))),
            react_1.default.createElement(lib_1.ListItem, null,
                react_1.default.createElement("b", null, translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item7.heading')),
                "\u00A0",
                translate('gdpr.privacy.notification.paragraph.nine.modal2.list.item7.content'))));
    }
    getExtraInfoElement(id, type) {
        const { translate } = this.translateStore;
        let heading;
        let textAreaComment;
        switch (type) {
            case ContactForm_1.ContactFormType.ACCESS_DATA:
                heading = translate('gdpr.privacy.accessData.heading');
                textAreaComment = translate('gdpr.privacy.accessData.textAreaComment');
                break;
            case ContactForm_1.ContactFormType.FORGOTTEN:
                heading = translate('gdpr.privacy.forgotten.heading');
                textAreaComment = translate('gdpr.privacy.forgotten.textAreaComment');
                break;
            default:
                heading = undefined;
                textAreaComment = undefined;
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            translate('gdpr.privacy.notification.paragraph.nine.modal2.extraInfo.prefix'),
            "\u00A0",
            react_1.default.createElement(GaButton_1.default, { id: id, text: translate('gdpr.privacy.notification.paragraph.nine.modal2.extraInfo.linkText'), link: true, onClick: () => this.publicPrivacyNoticeStore.openContactInformationModal(type, heading, textAreaComment) }),
            this.locationStore.currentLanguage === crm_components_1.Language.RU && translate('gdpr.privacy.notification.paragraph.nine.modal2.extraInfo.suffix')));
    }
};
RightsPersonalDataContent = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], RightsPersonalDataContent);
exports.default = RightsPersonalDataContent;
